import { Link } from "react-router-dom";
import { PlaneIcon } from "./icons";

const EmptyState = () => (
  <div className="col-span-full flex flex-col items-center justify-center py-16 px-4">
    <div className="w-20 h-20 rounded-full bg-gray-100 flex items-center justify-center mb-4">
      <PlaneIcon />
    </div>
    <h3 className="text-xl font-semibold text-gray-900 mb-2">No itineraries yet</h3>
    <p className="text-gray-500 text-center mb-6 max-w-md">
      Start planning your next adventure! Create your first AI-powered itinerary and make your travel dreams come true.
    </p>
    <Link
      to="/plan"
      className="inline-flex items-center px-6 py-3 bg-teal-600 text-white font-semibold rounded-full hover:bg-teal-700 transition-colors cursor-pointer"
    >
      <span className="mr-2">+</span>
      Create Your First Trip
    </Link>
  </div>
);

export default EmptyState;
